import { pgTable, uuid, text, unique, integer, boolean, foreignKey, primaryKey, } from 'drizzle-orm/pg-core';
import { relations } from 'drizzle-orm';
import { sortOrder, tableBase } from '../utils';
import { MetricType } from '../enums';
import { AdminExerciseMetric, AdminTrainingFocus, AdminTrainingType, } from './misc';
export const AdminScheme = pgTable('admin_scheme', {
    ...tableBase,
    name: text('name').notNull(),
    trainingTypeId: uuid('training_type_id').notNull(),
}, (table) => ({
    pk: primaryKey({
        columns: [table.id],
    }),
    typeFk: foreignKey({
        columns: [table.trainingTypeId],
        foreignColumns: [AdminTrainingType.id],
    }),
}));
export const AdminScheme_Relations = relations(AdminScheme, ({ many }) => ({
    sets: many(AdminSchemeSet),
    metrics: many(AdminSchemeMetric),
    focuses: many(AdminSchemeFocus),
}));
export const AdminSchemeMetric = pgTable('admin_scheme_metric', {
    ...tableBase,
    sortOrder,
    schemeId: uuid('scheme_id').notNull(),
    metricId: uuid('metric_id').notNull(),
    metricName: text('metric_name').notNull(),
    metricType: MetricType('metric_type').notNull(),
}, (table) => ({
    pk: primaryKey({
        columns: [table.id],
    }),
    uq1: unique().on(table.schemeId, table.metricId),
    uq2: unique().on(table.schemeId, table.sortOrder),
    metricFk: foreignKey({
        columns: [table.metricId],
        foreignColumns: [AdminExerciseMetric.id],
    }),
    schemeFk: foreignKey({
        columns: [table.schemeId],
        foreignColumns: [AdminScheme.id],
    }),
}));
export const AdminSchemeMetric_Relations = relations(AdminSchemeMetric, ({ one }) => ({
    scheme: one(AdminScheme, {
        fields: [AdminSchemeMetric.schemeId],
        references: [AdminScheme.id],
    }),
}));
export const AdminSchemeSet = pgTable('admin_scheme_set', {
    ...tableBase,
    sortOrder,
    sessionIndex: integer('session_index').notNull(),
    cycleIndex: integer('cycle_index').notNull(),
    schemeId: uuid('scheme_id').notNull(),
}, (table) => ({
    pk: primaryKey({
        columns: [table.id],
    }),
    uq: unique().on(table.schemeId, table.sessionIndex, table.cycleIndex, table.sortOrder),
    schemeFk: foreignKey({
        columns: [table.schemeId],
        foreignColumns: [AdminScheme.id],
    }),
}));
export const AdminSchemeSet_Relations = relations(AdminSchemeSet, ({ one, many }) => ({
    scheme: one(AdminScheme, {
        fields: [AdminSchemeSet.schemeId],
        references: [AdminScheme.id],
    }),
    metrics: many(AdminSchemeSetMetric),
}));
export const AdminSchemeSetMetric = pgTable('admin_scheme_set_metric', {
    ...tableBase,
    schemeSetId: uuid('scheme_set_id').notNull(),
    metricId: uuid('metric_id').notNull(),
    input: text('input').notNull(),
    forCollection: boolean('for_collection').notNull(),
}, (table) => ({
    pk: primaryKey({
        columns: [table.id],
    }),
    uq: unique().on(table.schemeSetId, table.metricId),
    metricFk: foreignKey({
        columns: [table.metricId],
        foreignColumns: [AdminExerciseMetric.id],
    }),
    schemeSetFk: foreignKey({
        columns: [table.schemeSetId],
        foreignColumns: [AdminSchemeSet.id],
    }),
}));
export const AdminSchemeSetMetric_Relations = relations(AdminSchemeSetMetric, ({ one }) => ({
    set: one(AdminSchemeSet, {
        fields: [AdminSchemeSetMetric.schemeSetId],
        references: [AdminSchemeSet.id],
    }),
}));
export const AdminSchemeFocus = pgTable('admin_scheme_focus', {
    ...tableBase,
    sortOrder,
    schemeId: uuid('scheme_id').notNull(),
    focusId: uuid('focus_id').notNull(),
}, (table) => ({
    pk: primaryKey({
        columns: [table.id],
    }),
    uq1: unique().on(table.schemeId, table.focusId),
    uq2: unique().on(table.schemeId, table.sortOrder),
    schemeFk: foreignKey({
        columns: [table.schemeId],
        foreignColumns: [AdminScheme.id],
    }),
    focusFk: foreignKey({
        columns: [table.focusId],
        foreignColumns: [AdminTrainingFocus.id],
    }),
}));
//# sourceMappingURL=scheme-library.js.map